<div class="animate__animated animate__fadeInRight">
    <div class="col">
        <mat-card class="mat_card_trabajadores">
            <h1 class>Módulo de anexos</h1>
        </mat-card>
    </div>
    <br/>
    <div class="col">
        <p-card>
            <p-tabView>
                <p-tabPanel header="Generar anexo trabajador">
                    <div class="animate__animated animate__fadeInRight">
                        <app-generar-anexo-contrato></app-generar-anexo-contrato>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Generar anexos masivos">
                    <div class="animate__animated animate__fadeInRight">
                        <app-generar-anexos-masivos></app-generar-anexos-masivos>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </p-card>
    </div>
</div>